import React from 'react'

interface Props {
  label: string
  onClickHandler?: () => void
  type?: 'button' | 'submit'
  variant?: 'primary' | 'secondary'
  disabled?: boolean
  /** Native tooltip, useful for explaining why a button is disabled. */
  title?: string
}

const TextButton = ({
  label,
  onClickHandler,
  variant = 'primary',
  type = 'button',
  disabled = false,
  title,
}: Props) => {
  return (
    <button
      type={type}
      onClick={onClickHandler}
      disabled={disabled}
      title={title}
      className={`disabled:opacity-40 disabled:cursor-not-allowed font-medium ${variant === 'primary' && 'text-primaryBlue'} ${variant === 'secondary' && 'text-lightGray'}`}
    >
      {label}
    </button>
  )
}

export default TextButton
